import React from 'react';
import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';

interface Props {
  children: string;
}
const HeadOverride: React.FC<Props> = ({ children }) => {
  const { t } = useTranslation();
  const seoTitle = 'seo-title-';
  const localizedSEOTitleExists =
    t(seoTitle + children) !== seoTitle + children;

  return (
    <Helmet>
      <title>
        {localizedSEOTitleExists ? t(seoTitle + children) : t(children)} -{' '}
        {t('DataLouder')}
      </title>
      <meta name="description" content={t('seo-description-' + children)} />
    </Helmet>
  );
};

export default HeadOverride;
